export const privacyCopy = {
    en: {
        title: "Privacy Policy",
        eyebrow: "LARIVA — Italian Lakes Collection",
        updated: "Last updated: July 2026",
        intro: "This Privacy Policy explains how personal data collected through the LARIVA website (larivacomo.com) is handled.",
        sections: [
            {
                n: "01",
                h: "Data Controller",
                p: [
                    "The data controller responsible for personal data collected through this website is:",
                    "NEST SAGL\nVia San Giorgio 29\n6834 Morbio Inferiore\nSwitzerland\nSwiss UID: CHE-454.536.077",
                    "Privacy contact: privacy@larivacomo.com",
                ],
            },
            {
                n: "02",
                h: "Data We Collect",
                p: [
                    "When you submit the Request Access form, we collect the information you provide: name, company or property, role, email address, phone number, country, type of venue, the content of your message, and the website language used (English or Italian).",
                ],
            },
            {
                n: "03",
                h: "Purpose of Processing",
                p: [
                    "Your data is used exclusively to review and respond to your hospitality enquiry, to send you a confirmation of receipt, and to contact you regarding a potential hospitality partnership.",
                ],
            },
            {
                n: "04",
                h: "Legal Basis",
                p: [
                    "Processing is based on your consent, given by submitting the form, and on our legitimate interest in responding to business enquiries.",
                ],
            },
            {
                n: "05",
                h: "Storage & Retention",
                p: [
                    "Enquiry data is stored securely and retained only for as long as necessary to handle your enquiry and any resulting business relationship. You may request deletion of your data at any time.",
                ],
            },
            {
                n: "06",
                h: "Recipients & Processors",
                p: [
                    "To deliver enquiry notifications and confirmation emails, your data is processed by our email delivery service provider acting on our instructions. We do not sell, rent or share your personal data with third parties for marketing purposes.",
                ],
            },
            {
                n: "07",
                h: "Your Rights",
                p: [
                    "Under applicable Swiss data protection law (nFADP) and, where applicable, the GDPR, you have the right to access, rectify or delete your personal data, to restrict or object to its processing, and to withdraw your consent at any time.",
                    "To exercise your rights, contact: privacy@larivacomo.com",
                ],
            },
            {
                n: "08",
                h: "Cookies & Technical Storage",
                p: [
                    "This website uses only essential technical storage in your browser to remember your language preference. No advertising or third-party marketing cookies are used.",
                ],
            },
            {
                n: "09",
                h: "Changes to This Policy",
                p: [
                    "This Privacy Policy may be updated to reflect legal or operational changes. The current version is always available on this page.",
                ],
            },
        ],
        back: "Back to larivacomo.com",
    },
    it: {
        title: "Privacy Policy",
        eyebrow: "LARIVA — Italian Lakes Collection",
        updated: "Ultimo aggiornamento: luglio 2026",
        intro: "La presente Privacy Policy spiega come vengono trattati i dati personali raccolti attraverso il sito LARIVA (larivacomo.com).",
        sections: [
            {
                n: "01",
                h: "Titolare del Trattamento",
                p: [
                    "Il titolare del trattamento dei dati personali raccolti attraverso questo sito è:",
                    "NEST SAGL\nVia San Giorgio 29\n6834 Morbio Inferiore\nSvizzera\nUID svizzera: CHE-454.536.077",
                    "Contatto privacy: privacy@larivacomo.com",
                ],
            },
            {
                n: "02",
                h: "Dati Raccolti",
                p: [
                    "Quando invii il modulo Richiedi Accesso, raccogliamo le informazioni che fornisci: nome, azienda o proprietà, ruolo, indirizzo email, numero di telefono, paese, tipo di struttura, contenuto del messaggio e lingua del sito utilizzata (inglese o italiano).",
                ],
            },
            {
                n: "03",
                h: "Finalità del Trattamento",
                p: [
                    "I tuoi dati sono utilizzati esclusivamente per esaminare e rispondere alla tua richiesta hospitality, per inviarti una conferma di ricezione e per contattarti in relazione a una possibile partnership hospitality.",
                ],
            },
            {
                n: "04",
                h: "Base Giuridica",
                p: [
                    "Il trattamento si basa sul tuo consenso, espresso con l'invio del modulo, e sul nostro legittimo interesse a rispondere alle richieste commerciali.",
                ],
            },
            {
                n: "05",
                h: "Conservazione dei Dati",
                p: [
                    "I dati delle richieste sono conservati in modo sicuro e solo per il tempo necessario a gestire la tua richiesta ed eventuali rapporti commerciali che ne derivino. Puoi richiedere la cancellazione dei tuoi dati in qualsiasi momento.",
                ],
            },
            {
                n: "06",
                h: "Destinatari e Responsabili",
                p: [
                    "Per recapitare le notifiche delle richieste e le email di conferma, i tuoi dati sono trattati dal nostro fornitore di servizi di invio email, che agisce secondo le nostre istruzioni. Non vendiamo, affittiamo né condividiamo i tuoi dati personali con terze parti per finalità di marketing.",
                ],
            },
            {
                n: "07",
                h: "I Tuoi Diritti",
                p: [
                    "Ai sensi della normativa svizzera sulla protezione dei dati (nLPD) e, ove applicabile, del GDPR, hai il diritto di accedere ai tuoi dati personali, rettificarli o cancellarli, limitarne o opporti al trattamento e revocare il consenso in qualsiasi momento.",
                    "Per esercitare i tuoi diritti, scrivi a: privacy@larivacomo.com",
                ],
            },
            {
                n: "08",
                h: "Cookie e Archiviazione Tecnica",
                p: [
                    "Questo sito utilizza esclusivamente l'archiviazione tecnica del browser per ricordare la tua preferenza di lingua. Non vengono utilizzati cookie pubblicitari o di marketing di terze parti.",
                ],
            },
            {
                n: "09",
                h: "Modifiche alla Presente Policy",
                p: [
                    "La presente Privacy Policy può essere aggiornata per riflettere modifiche legali o operative. La versione corrente è sempre disponibile in questa pagina.",
                ],
            },
        ],
        back: "Torna a larivacomo.com",
    },
};
